import {
  BillingProvider,
  Country,
  Currency,
  EntitlementEntityType,
  EntitlementFulfillmentType,
  EntitlementPurchaserType,
} from '@prisma/client';

export const BASE_URL = 'marketplace';

export interface IRequestNewServicesParams {
  message: string;
  serviceName: string;
  country: Country;
  companyId: number;
}

export interface ListItemsQueryDTO {
  country?: Country;
  searchQuery?: string;
  offset?: number;
  limit?: number;
  type?: 'one-time' | 'recurring';
  sortBy?: 'AZ' | 'ZA' | 'LOW_TO_HIGH' | 'HIGH_TO_LOW' | 'NEWEST_FIRST';
}

export enum PricingType {
  ONE_TIME = 'one-time',
  RECURRING = 'recurring',
}

export interface IMarketplaceServicesItem {
  itemId: string;
  name: string;
  externalName: string;
  description: string;
  pricingType: PricingType;
  currencyCode: Currency;
  startingPrice: number;
  updatedAt: number;
  isRecommended: boolean;
  country: Country;
  variants: IMarketplaceServicesItemVariant[];
  isIncorporation?: boolean;
  isSingleSelection?: boolean;
}

type PricingModelEnum =
  | 'flat_fee'
  | 'per_unit'
  | 'tiered'
  | 'volume'
  | 'stairstep';

export interface IMarketplaceServicesItemVariant {
  id: string;
  name?: string;
  itemId: string;
  itemFamilyId: string;
  status: string;
  externalName?: string;
  pricingModel: PricingModelEnum;
  price?: number;
  period?: number;
  currencyCode: Currency;
  periodUnit?: string;
}

export enum PurchasedServicesStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
}

export type TAllPurchasedServicesResponse = {
  id: string;
  status: PurchasedServicesStatus;
  startDate: string; // timestamp
  endDate?: string; // timestamp
  isRecurring: boolean;
  productName: string;
  entity: {
    entityName: string;
    entityId: string;
  };
};

export type IEntitlementWithEntityName = IEntitlement & {
  entityName: string;
};

export enum ServiceStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
}

export enum ServiceSortBy {
  AZ = 'AZ',
  ZA = 'ZA',
  LOW_TO_HIGH = 'LOW_TO_HIGH',
  HIGH_TO_LOW = 'HIGH_TO_LOW',
  NEWEST_FIRST = 'NEWEST_FIRST',
  OLDEST_FIRST = 'OLDEST_FIRST',
}

export interface IEntitlement {
  id: string;
  purchaserType: EntitlementPurchaserType;
  purchaserId: string;
  billingSourceProvider: BillingProvider;
  billingSourceId: string;
  productIdentifier: string;
  forEntityType: EntitlementEntityType;
  forEntityId?: string;
  fulfillmentEntityType?: EntitlementFulfillmentType;
  fulfillmentEntityId?: string;
  startDate?: string;
  endDate?: string;
  isRecurring?: boolean;
  createdAt?: Date;
  lastUpdatedAt?: Date;
}
